<template>
  <section>
    <div class="title-area">
      <h2 class="sub-title">
        {{ Ranking.all[lang] }}
      </h2>
      <!-- 更新時間 -->
      <div
        class="update-time"
        v-if="
          !isLoadingRanking &&
          !isNotFound &&
          !isServerError &&
          dataRanking.metadata.event_date_at[lang]
        "
      >
        {{ dataRanking.metadata.event_date_at[lang] }}
      </div>
    </div>
    <!-- 絞り込み -->
    <div class="narrow-down">
      <h3 class="h3-title">
        {{ Ranking.filter[lang] }}
        <span class="sub">
          {{ Ranking.multi[lang] }}
        </span>
      </h3>
      <div class="select-area">
        <dl
          class="narrow-down-list"
          v-for="(condition, index) in dataEventSummary.conditions"
          :key="index"
        >
          <dt class="narrow-down-list__team">
            <label for="refined-search-id" class="label">
              {{
                isCompany && condition.name == "居住地"
                  ? "都道府県"
                  : condition.name
              }}
            </label>
          </dt>
          <dd class="narrow-down-list__description">
            <select
              id="refined-search-id"
              class="select"
              :name="`${condition.param}`"
              v-model="$data['select' + condition.param]"
            >
              <option value="" selected>
                {{ Ranking.reserve[lang] }}
              </option>
              <option
                v-for="(group, index) in condition.groups"
                :key="index"
                :value="group.code"
              >
                {{ group.name }}
              </option>
            </select>
          </dd>
        </dl>
        <button
          type="button"
          @click="emitTypeNarrowingDown()"
          class="button filter flex-all-center"
        >
          <span>
            {{ Ranking.apply[lang] }}
          </span>
        </button>
        <button type="button" @click="emitRanking()" class="button">
          {{ Ranking.clear[lang] }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Ranking from "../../../assets/constants/ranking/ranking.json";
export default {
  data() {
    return {
      selectgender: "",
      selectage: "",
      selectcountry: "",
      selectbranch: "",
      selectdepartment: "",
      selectaffiliation: "",
    };
  },
  methods: {
    /**
     * 旧イベント area=都道府県コード
     * 束ね area=99(日本) country=都道府県コード
     */
    emitTypeNarrowingDown: function () {
      this.$emit(
        "type-narrowing-down",
        this.selectgender,
        this.selectage,
        this.selectcountry,
        this.selectcountry,
        this.selectbranch,
        this.selectdepartment,
        this.selectaffiliation
      );
    },
    emitRanking: function () {
      // 絞り込み初期化
      this.selectbranch = "";
      this.selectdepartment = "";
      this.selectaffiliation = "";
      this.selectgender = "";
      this.selectage = "";
      this.selectcountry = "";
      this.$emit("initial-ranking");
    },
  },
  props: {
    isLoadingRanking: Boolean,
    isNotFound: Boolean,
    isServerError: Boolean,
    isCompany: Boolean,
    dataRanking: Object,
    dataEventSummary: Object,
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  name: "RefinedSearch",
};
</script>

<style scoped>
.title-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .sub-title {
    font-size: 32px;
    font-weight: 900;
  }
}
.narrow-down {
  margin: 32px 0 0 0;
  padding: 30px 40px 33px 40px;
  background-color: #eee;

  .h3-title {
    font-size: 24px;

    .sub {
      margin: 0 0 0 15px;
      font-size: 14px;
      font-weight: normal;
    }
  }

  .select-area {
    margin: 25px 0 0 0;
    display: flex;

    .narrow-down-list {
      margin: 0 30px 0 0;

      &:last-of-type {
        margin: 0 25px 0 0;
      }

      &__team {
        line-height: 1;
        font-size: 20px;
        font-weight: bold;
      }

      &__description {
        margin: 10px 0 0 0;

        .label {
          font-size: 20px;
        }

        .select {
          padding: 0 22px 0 15px;
          width: 180px;
          height: 35px;
          border: solid 1px #000;
          border-radius: 6px;
          font-size: 14px;
          background: #fff url("../../../assets/images/arrow-down.svg")
            no-repeat center right 10px;
          cursor: pointer;
        }
      }
    }

    .button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 135px;
      height: 65px;
      border: solid 1px #000;
      background-color: #fff;

      &:not(:last-of-type) {
        margin: 0 25px 0 0;
      }

      &:hover {
        color: #fff;
        background-color: #000;
      }
    }

    .filter {
      &::before {
        content: "";
        display: inline-block;
        width: 18px;
        height: 16px;
        margin: 0 4px 0 0;
        background: url("../../../assets/images/filter.svg") no-repeat center /
          18px 16px;
      }

      &:hover {
        &::before {
          background: url("../../../assets/images/filter-hover.svg") no-repeat
            center / 18px 16px;
        }
      }
    }
  }
}
.title-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .update-time {
    font-size: 16px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/ranking/RefinedSearch.vue